import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { LearningSummaryTitle } from "../../../../Constants/Constants";
import { GeneralLearning } from "../../../../Data/General/Widgets/General";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";

const LearningSummary = () => {
  return (
    <Col xxl="5" sm="6" className="box-col-6">
      <Card>
        <DashboardCommonHeader title={LearningSummaryTitle} text="(80% activity growth)" dropdownClass="dropdown-toggle" />
        <CardBody className="pb-0">
          <div id="general-learning">
            <ReactApexChart options={GeneralLearning} series={GeneralLearning.series} type="line" height={276} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LearningSummary;
